import api from "@/services/api";

const methods = api.getPrefixedMethods("settings");

export const settingsService = {
  getCustomTags() {
    return methods.get("tags");
  },
  updateCustomTags(scope, tags) {
    return methods.put("tags", { scope, tags });
  },
  resetCustomTags(scope) {
    return methods.delete("tags", { params: { scope } });
  },
  getActionNeededStatuses() {
    return methods.get("action-needed");
  },
  updateActionNeededStatuses(scope, statuses) {
    return methods.put("action-needed", { scope, statuses });
  },
  resetActionNeededStatuses(scope) {
    return methods.delete("action-needed", { params: { scope } });
  },
};
